const emptyPermissions = () => ({edit: {roles: [], users: []}, append: {roles: [], users: []}});
function checklistRights(task, list, user) {
    const id = Number(user.userId || user.user_id || user.id);
    const admin = (user.roles || []).includes('Admin');
    const owner = Number(task.author) === id;
    const responsible = Number(task.responsible_person) === id;
    const helper = (task.executors || []).some(row => Number(row.user_id) === id);
    const read = admin || owner || responsible || helper;
    const manage = admin || owner;
    const allowed = key => {
        const grant = list && list.permissions && list.permissions[key] || {};
        return read && (manage || (grant.users || []).some(value => Number(value) === id) ||
            responsible && (grant.roles || []).includes('responsible') || helper && (grant.roles || []).includes('helpers'));
    };
    return {read, manage, toggle: read, edit: allowed('edit'), append: allowed('append')};
}
function itemTiming(item, point, now = new Date()) {
    if (!point || point.deleted_at) return null;
    const due = new Date(point.due_at).getTime();
    if (!Number.isFinite(due)) return null;
    if (item.checked) return new Date(item.completed_at).getTime() <= due ? {key: 'on_time', text: 'В срок', variant: 'success'} : {key: 'late', text: 'С опозданием', variant: 'warning'};
    return new Date(now).getTime() > due ? {key: 'overdue', text: 'Просрочен', variant: 'danger'} : null;
}
module.exports = {emptyPermissions, checklistRights, itemTiming};
